import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DeviceService } from "./device.service";
import { StorageService } from "./storage.service";

@Injectable({
    providedIn: 'root',
})
export class LogoutService {
    private readonly loggedOutSubject = new BehaviorSubject(false);
    public readonly loggedOut$ = this.loggedOutSubject.asObservable();

    constructor(
        private storageService: StorageService,
        private deviceService: DeviceService,
    ) { }

    performLogout = (): void => {
        const deviceId = this.deviceService.getDeviceId();
       
        this.storageService.clearAll();
        this.storageService.setItem(this.deviceService.deviceIdKey, deviceId);
        this.loggedOutSubject.next(true);
    }
}